<template>
    <div class="adjustmentReport">
        <!-- <PlanReport title="原规划内容" :plan="plan" :version="version"></PlanReport> -->
        <div class='adjustBox'>
            <p class='adjustTitle'>原规划内容</p>
            <PlanReport :plan="planLast" :version="version"></PlanReport>
        </div>
        <div class='adjustBox'>
            <p class='adjustTitle'>调整规划内容</p>
            <PlanReport :plan="plan" :version="version" :professional="professional"></PlanReport>
        </div>
        <AdjustmentReport
            :targetCareer="adjustmentData.targetCareer"
            :university="adjustmentData.university"
            :version="version"
            :further="adjustmentData.further"
            :choose="adjustmentData.choose"
            :professional="professional"
        >
        </AdjustmentReport>
    </div>
</template>
<script>
import PlanReport from '@/components/consultant/planningContent/PlanReport.vue'
import AdjustmentReport from '@/components/consultant/planningContent/AdjustmentReport.vue'
export default {
    name: "adjustmentReport",
    components: {
        PlanReport,
        AdjustmentReport
    },
    data() {
        return {

            adjustmentData: {
                targetCareer:null,
                university:null,
                further:null,
                choose:null,
            },
            planReportTitle: '原规划内容',
            planLast:{},
            plan:{},
            version:'',
            professional:'',
        }
    },
    methods: {
        adjustPlanCompared(){
            let oldId = this.$route.query.lastId;
            let newId = this.$route.query.id;
            this.$ajax.post(this.G_acapi + this.ports.parent.student.planningContent.adjustPlanComparedByParent,{
                oldId: oldId,
                newId:newId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    console.log(res)
                    this.adjustmentData = res.data.data;
                    this.professional = res.data.data.targetCareer.professional
                    console.log(this.professional,'版本号家长')
                }
            })
        },
        getPlanById(id){
            this.$ajax.post(this.G_acapi + this.ports.parent.student.planningContent.getPlanByIdByParent, {
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.plan = res.data.data;
                    this.version = res.data.data.version
                    console.log(this.version)
                }
            })
        },
        getPlanByIdLast(id){
            this.$ajax.post(this.G_acapi + this.ports.parent.student.planningContent.getPlanByIdByParent, {
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.planLast = res.data.data;
                }
            })
        },
    },
    created() {
        this.getPlanByIdLast(this.$route.query.lastId);
        this.getPlanById(this.$route.query.id);
        this.adjustPlanCompared();
    }
}
</script>

<style scoped lang="less">
.adjustmentReport {
    padding: 25px 30px;
    background-color: #fff;
    .adjustTitle {
        font-size: 22px;
        font-weight: 500;
        color: #12A1F0;
        line-height: 50px;
        //margin-bottom: 20px;
    }
}
</style>